/**
 * Created by shubham on 24/4/18.
 */

import { Component } from '@angular/core';
import { APPCONFIG } from '../../config';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpService } from '../../shared/services/http.service'
import { MdDialog,MdDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DialogComponent } from '../../dialog/dialog.component';
import {SessionHandler} from "../../shared/services/session-handler.service";

@Component({
    template: require('./add-edit-user.component.html')
})

export class AddEditUserComponent {
    data: any = [];
    dialogRef;
    userDetails:any;
    UserForm: FormGroup;
    UserFormDetails: any;
    id: any;
    emailPattern = APPCONFIG.emailPattern;
    //passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
    passwordPattern = /^(?=.*?[A-Za-z])(?=.*?[0-9]).{5,}$/;
    settings = {};
    LanguageDetails = [];
    passwordErrorMsg: string = '';

    constructor(private router: Router, public sessionHandler: SessionHandler, private route: ActivatedRoute, private httpService: HttpService, private formBuilder: FormBuilder, private dialog: MdDialog) {
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        this.getLanguages();
    }

    public getLanguages(){
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(
            res => { this.saveLanguageResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    validateName(event: any) {
        return APPCONFIG.validNameRegex.test(event.key);
    }
    public saveLanguageResponse(res) {
        if(res){
            if(res.items){
                this.LanguageDetails = res.items;
            }
        }
        this.httpService.onEnd();
    }

    buildForm() {
        this.UserForm = this.formBuilder.group({
            firstName: this.formBuilder.control(null, [Validators.required]),
            lastName: this.formBuilder.control(null, [Validators.required]),
            password: this.formBuilder.control('', [Validators.required, Validators.minLength(8), Validators.maxLength(8), Validators.pattern(this.passwordPattern)]),
            confirmPassword: this.formBuilder.control('', [Validators.required]),
            email: this.formBuilder.control(null, [Validators.required, Validators.pattern(this.emailPattern)]),
            languageId: this.formBuilder.control(null, [Validators.required]),
        },  {validator: this.checkPasswords});
        this.UserForm.valueChanges.subscribe(data => {
            this.UserFormDetails = this.UserForm.getRawValue();
            this.UserFormDetails.validate = this.UserForm.valid;
        });

        this.UserForm.get('password').valueChanges.subscribe(data=> {
            this.validatePassword(data);
        })
    }

    validatePassword(data) {
        const firstName = this.UserForm.get('firstName').value || '';
        const lastName = this.UserForm.get('lastName').value || '';

        if (data != null) {
            this.UserForm.get('password').setErrors({'incorrect': true});

            const hasUpper = /[A-Z]/.test(data);
            const hasLower = /[a-z]/.test(data);
            const hasDigit = /[0-9]/.test(data);
            const minLength = data.length >= 8;
            const validSymbols = /^[a-zA-Z0-9!@#$%&*?]*$/.test(data);
            const containsFirstName = firstName && data.toLowerCase().includes(firstName.toLowerCase());
            const containsLastName = lastName && data.toLowerCase().includes(lastName.toLowerCase());

            if (!hasUpper || !hasLower) {
                this.passwordErrorMsg = "pass_one_upper_lower_char";
            } else if (!hasDigit) {
                this.passwordErrorMsg = "pass_one_number";
            } else if (!minLength) {
                this.passwordErrorMsg = "pass_least_8_chars";
            } else if(data.toLowerCase().includes(this.userDetails.userId_WPASS.toLowerCase())){
                    this.passwordErrorMsg = "pass_no_userId";
            } else if (!validSymbols) {
                this.passwordErrorMsg = "pass_invalid_symbol"; //new
            } else if (containsFirstName) {
                this.passwordErrorMsg = "pass_contains_firstname"; //new
            } else if (containsLastName) {
                this.passwordErrorMsg = "pass_contains_lastname"; //new
            } else {
                this.passwordErrorMsg = "";
                this.UserForm.get('password').setErrors(null);
                return true;
            }
        }
        return false;
    }

    showPassword(input: any): any {
        input.type = input.type === 'password' ?  'text' : 'password';
    }

    checkPasswords(group: FormGroup) {
        if(group.get('password').value === group.get('confirmPassword').value){
            group.get('confirmPassword').setErrors(null);
            return null;
        } else{
            group.get('confirmPassword').setErrors({'incorrect': true});
            return {'mismatch': true};
        }
    }

    public saveUserData(){
        if(!this.validatePassword(this.UserForm.get('password').value)) {
            return;
        }
        
        this.httpService.postRequest(this.UserFormDetails,'partnerOperationsApi/v1/createCompanyUser').subscribe(
            res => { this.saveResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveResponse(res){
        if(res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'user_creation_failed';
        } else {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = "registration_rqst_notify";
            //this.dialogRef.componentInstance.msg = "User Created Successfully";
            this.dialogRef.afterClosed().subscribe(result => {
                this.router.navigateByUrl('/app/partners-dashboard');
            });
        }
    }

    ngOnInit(): void {
        this.buildForm();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user/add-edit-user/add-edit-user.component.ts